"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const selectors_1 = require("../modules/selectors");
const formLoaded = state => formId => {
    const formIds = (0, selectors_1.formIdsSelector)(state);
    return formIds.includes(formId);
};
exports.default = formLoaded;
//# sourceMappingURL=form-loaded.js.map